(function () {
  'use strict';
  // Houdt de betaalde 14CT-upgrade-regel in sync met het aantal kit-regels met
  // property Canvas: 14 CT. Regels met '_Canvas upgrade voor' zijn automatisch
  // toegevoegd; regels zonder die property zijn bewuste losse aankopen (cart-upsell).
  var UPGRADE_ID = 53248566133002;
  var AUTO_PROP = '_Canvas upgrade voor';
  var UPGRADE_HANDLE = 'upgrade-naar-14ct-canvas';
  var syncing = false;
  var pending = false;
  var scheduleTimer = null;
  var lastCart = null;

  function rootPath() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function route(p) { return rootPath().replace(/\/$/, '') + p; }
  function getCart() {
    return fetch(route('/cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart fetch failed'); return r.json(); })
      .then(function (cart) { lastCart = cart; return cart; });
  }
  function post(path, body) {
    return fetch(route(path), { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart mutate failed'); return r.json(); });
  }

  function isUpgrade(item) { return Number(item.variant_id) === UPGRADE_ID; }
  function isAuto(item) { return isUpgrade(item) && item.properties && item.properties[AUTO_PROP]; }
  function is14Kit(item) { return !isUpgrade(item) && item.properties && item.properties.Canvas === '14 CT'; }

  function analyse(cart) {
    var expected = 0, autoLines = [], manualQty = 0, kit14 = [];
    (cart.items || []).forEach(function (item) {
      if (is14Kit(item)) { expected += item.quantity; kit14.push(item); }
      else if (isAuto(item)) autoLines.push(item);
      else if (isUpgrade(item)) manualQty += item.quantity;
    });
    var autoQty = autoLines.reduce(function (s, i) { return s + i.quantity; }, 0);
    return { expected: expected, autoLines: autoLines, autoQty: autoQty, manualQty: manualQty, kit14: kit14 };
  }

  function reconcile() {
    if (syncing) { pending = true; return Promise.resolve(); }
    syncing = true;
    return getCart().then(function (cart) {
      var a = analyse(cart);
      var covered = a.autoQty + a.manualQty;
      if (covered < a.expected) {
        var diff = a.expected - covered;
        if (a.autoLines.length) {
          return post('/cart/change.js', { id: a.autoLines[0].key, quantity: a.autoLines[0].quantity + diff }).then(function () { return true; });
        }
        var props = {};
        props[AUTO_PROP] = a.kit14.length ? a.kit14[0].product_title : 'Borduurpakket';
        return post('/cart/add.js', { items: [{ id: UPGRADE_ID, quantity: diff, properties: props }] }).then(function () { return true; });
      }
      if (a.autoQty > 0 && covered > a.expected) {
        var targetAuto = Math.max(0, a.expected - a.manualQty);
        var remove = a.autoQty - targetAuto;
        var chain = Promise.resolve();
        for (var i = a.autoLines.length - 1; i >= 0 && remove > 0; i--) {
          var take = Math.min(a.autoLines[i].quantity, remove);
          (function (line, newQty) {
            chain = chain.then(function () { return post('/cart/change.js', { id: line.key, quantity: newQty }); });
          })(a.autoLines[i], a.autoLines[i].quantity - take);
          remove -= take;
        }
        return chain.then(function () { return true; });
      }
      return false;
    }).then(function (changed) {
      syncing = false;
      if (pending) { pending = false; return reconcile(); }
      if (changed) { getCart().then(function () { refresh(); }); }
    }).catch(function (err) {
      syncing = false; pending = false;
      console.error('[canvas-guard]', err);
    });
  }

  // Klant verwijdert de upgrade-regel → kits eerlijk terug naar 11 CT.
  function removeUpgrade(key) {
    syncing = true;
    return getCart().then(function (cart) {
      var chain = Promise.resolve();
      var target = (cart.items || []).find(function (i) { return i.key === key; });
      if (target) chain = chain.then(function () { return post('/cart/change.js', { id: key, quantity: 0 }); });
      (cart.items || []).forEach(function (item) {
        if (!is14Kit(item)) return;
        chain = chain.then(function () {
          var props = {};
          for (var k in item.properties) { if (Object.prototype.hasOwnProperty.call(item.properties, k)) props[k] = item.properties[k]; }
          props.Canvas = '11 CT';
          return post('/cart/change.js', { id: item.key, quantity: item.quantity, properties: props });
        });
      });
      // Overige automatische upgrade-regels opruimen (expected is nu 0)
      (cart.items || []).forEach(function (item) {
        if (item.key !== key && isAuto(item)) {
          chain = chain.then(function () { return post('/cart/change.js', { id: item.key, quantity: 0 }); });
        }
      });
      return chain;
    }).then(function () {
      syncing = false;
      return getCart();
    }).then(function () { refreshHard(); }).catch(function (err) {
      syncing = false;
      console.error('[canvas-guard]', err);
      refreshHard();
    });
  }

  function onCartPage() { return location.pathname.indexOf('/cart') !== -1; }
  function refresh() {
    if (onCartPage()) { window.location.reload(); return; }
    if (window.StitchlyCRO && typeof window.StitchlyCRO.refresh === 'function') window.StitchlyCRO.refresh();
    if (window.halo && typeof window.halo.updateSidebarCart === 'function' && window.Shopify && typeof window.Shopify.getCart === 'function') {
      window.Shopify.getCart(function (cart) { window.halo.updateSidebarCart(cart); });
    }
  }
  function refreshHard() {
    if (onCartPage()) { window.location.reload(); return; }
    refresh();
  }

  function schedule() {
    if (scheduleTimer) clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(function () { scheduleTimer = null; reconcile(); }, 600);
  }

  // Cart-mutaties van thema/halo observeren zodat de upgrade-regel meebeweegt
  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_URL_RE.test(String(url))) {
      p.then(function (res) { if (res && res.ok && !syncing) schedule(); }, function () {});
    }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_URL_RE.test(String(url || ''))) {
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300 && !syncing) schedule(); });
    }
    return origOpen.apply(this, arguments);
  };

  // Verwijder-klik op de upgrade-regel in halo cart/side-cart afvangen
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!btn) return;
    var key = btn.getAttribute('data-line');
    if (!key) return;
    var line = lastCart ? (lastCart.items || []).find(function (i) { return i.key === key; }) : null;
    var isUp;
    if (line) {
      isUp = Number(line.variant_id) === UPGRADE_ID;
    } else {
      var scope = btn.closest('[data-item-row]') || btn.closest('.cart-item') || btn.closest('li') || btn.closest('tr');
      isUp = !!(scope && scope.querySelector('a[href*="' + UPGRADE_HANDLE + '"]'));
    }
    if (!isUp) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    removeUpgrade(key);
  }, true);

  window.StitchlyCanvasGuard = { sync: reconcile, removeUpgrade: removeUpgrade };

  function init() { getCart().then(function () { reconcile(); }).catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
